var XPortal = XPortal || {};

XPortal.EditActions = (function () {
    var self = {
        AutoSaveTimeout: 0,
        Actions: {},
        NodeActions: {},
        Messages: {},
        Exec: function (action, options, goptions) {
            if (self[action]) {
                const aopts = Object.assign(options, _.find(goptions.commands, c => c.action.toLowerCase() === action.toLowerCase()), { action: options.action });
                return self[action](aopts, goptions);
            }
            return false;
        },
        Init: function (options) {
            const container = options.container || $(XPortal.Main.DetialFormSelector);
            if (container.length == 0) return;
            const model = XPortal.Store.GetModelByName(options.modelName);
            if (!model) return;
            const settings = ensureDefaultActions(model.model, container);
            XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.ADD_MESSAGES, messages: settings.messages.savedetail, modelName: options.modelName });

            initNotifications(settings);
            const containerWithActions = (settings.isPopup) && container.closest(".modal-content").length ? container.closest(".modal-content") : container;
            const toolbar = containerWithActions.find(".detail-toolbar");
            toolbar.find(".action").each(function () {
                var $btn = $(this);
                var action = $btn.attr("data-action");
                self.Exec(action, { container, toolbar, button: $(this), action: "beforeedit", modelName: options.modelName }, settings);
                let toutid = 0;
                $btn.on("click", function (e) {
                    e.preventDefault();
                    if (!action) return;
                    clearTimeout(toutid);
                    toutid = setTimeout(function () {
                        XPortal.Loader.show({ selector: $btn, size: '3rem' });
                        self.Exec(action, { container, toolbar, button: $btn, action: "click", modelName: options.modelName }, settings);
                        XPortal.Loader.hide({ selector: $btn });
                    }, 250);
                });
            });
            XPortal.GridActions.SubscribeButtons(options.modelName, container);
        },
        EditViewMode: function (options, alloptions) {
            const model = XPortal.Store.GetModelByName(options.modelName).model || {};
            const entityId = model.UniqueId;
            const curModeIsView = model.isViewMode;
            const frmLdr = $(model.selector).find(".detail-preload");            
            const hddmode = frmLdr.find(".hdn-displaymode");
            //init

            if (options.action === "beforeedit") {       
                const vmodeCss = hddmode.attr("data-vdmodecss") || "d-mode-viewonly";         
                const vclass = [];
                if (model.IsCreating) vclass.push("d-none");
                if (model.Fields.find(x => x.editable) == null) vclass.push("d-none");

                if (curModeIsView) {                   
                    $(model.selector).addClass(vmodeCss);
                    cleanHtmlEditorForViewMode($(model.selector));
                } else {
                    $(model.selector).removeClass(vmodeCss);
                }
                return _.uniq(vclass).forEach(x =>
                        options.button.addClass(x));                
            }

            if (options.action !== "click")  return;
            //click
            
            model.isViewMode = !curModeIsView;

            const refreshPageView = function () {
                const frm = frmLdr.find(".detail-page-frm");
                const vmodeVal = curModeIsView ? "" : hddmode.attr("data-vdmode") || "viewonly";
                hddmode.val(vmodeVal);
                smoothChangeView();

                if (frm && frm.length && options.button.attr("data-reloadview") != '0')
                    frm.trigger("submit");                
            };

            if (curModeIsView == true)
                refreshPageView();
            else {
                XPortal.GridActions.ShowPage({
                    action: () => {
                        refreshPageView();
                    }
                });
            }
        },
        /* actions */
        SendMail: function (options, alloptions) { //options : container, button, action            
            if (options.action !== "click") return;
            let title = $("h1").length > 0 ? $("h1")[0].innerText : 'entity';
            const steps = new $.Deferred();
            const model = XPortal.Store.GetModelByName(options.modelName).model;
            const entityId = model.UniqueId;
            if (options.savebefore) {
                options.IsCreating = model.IsCreating;
                saveData(options).then(() => steps.resolve(true), () => steps.resolve(false));
            } else steps.resolve(true);
            steps.then(function (isOk) {
                if (!isOk) return;
                var strAll = "";
                var contentData = Object.assign({ entityAlias: model.EntityAlias, emailAddr: "", editLink: window.location.href });
                options.container.find(".form-group").each(function () {
                    let t = $(this).find("label").text();
                    let el = $(this).find(".detail-field");
                    let v = [];
                    el.each((x, xi) => {
                        let vi = $(xi).is(":input") ? $(xi).val() : $(xi).text();
                        if (vi && !v.find(vx => vx == vi)) v.push(vi);
                    });
                    let fieldMeta = el.attr("data-metadata-fieldname");
                    v = v.join(", ");
                    if (v && v.length > 0) strAll += t + " : " + v + "<br>";
                    if (fieldMeta) contentData[fieldMeta.toLowerCase()] = v;
                });
                contentData.all = strAll;

                var mfHtml = $(options.button).find(".sendMailTemplate").html();
                contentData.subject = XPortal.Template.TemplateToHtml(contentData, $(mfHtml).find(".xSubject").html(), alloptions.id);
                contentData.messageBody = XPortal.Template.TemplateToHtml(contentData, $(mfHtml).find(".xMessage").html(), alloptions.id);


                var recipientOptions = {
                    modelId: options.container.find("form").attr("uniqueId"),
                    entityAlias: contentData.entityAlias,
                    nodeId: alloptions.id,
                    emailSubject: contentData.subject,
                    emailBody: contentData.messageBody
                };
                recipientOptions.modelId = recipientOptions.modelId && recipientOptions.modelId.length ? recipientOptions.modelId : entityId;
                if (options.silent) { //send in silent mode                    
                    XPortal.Loader.show({ showOverlay: true });
                    XPortal.Notificator.AjaxCall({ data: kendo.stringify(recipientOptions), url: options.button.data().maillink }, function onSuccess(element, data) {
                        XPortal.Loader.hide({ 'selector': null });
                        self.ShowSendMailResult(data, options);
                    });
                    return;
                }
                options = {
                    button: options.button,
                    mailFormText: XPortal.Template.TemplateToHtml(contentData, mfHtml, recipientOptions.nodeId),
                    recipientOptions: recipientOptions,
                    IsCreating: options.IsCreating,
                    title: title,
                    notClose: options.notClose,
                    action: options.action
                };

                $.when(self.ShowMailForm(options)).then(function (xdata) {
                    self.ShowSendMailResult(xdata, options);
                });
            });
        },
        ShowSendMailResult: function (xdata, options) {
            if (xdata.State < 0) {
                XPortal.Store.ForceCloseForm(false);
                XPortal.EditForm.ShowErrorMessage(xdata, XPortal.Localization.GetCachedString("XFDetailForm.Errors.MailFailTitle", "").replace("{detailTitle}", options.title));
            } else {
                mfHtml = $($(options.button).find(".sendMailTemplate").html()).find(".xSuccess").html() || "";
                if (mfHtml.trim().length > 0)
                    XPortal.Modal.checkIfModal([{
                        dataset: {
                            showModal: true, modalTitle: options.title,
                            modalText: mfHtml
                        }
                    }]);
                else self.FormCloseReload(options, options.button.attr("data-success-url"));
            }
            $("#modalBox").off('hidden.bs.modal').on('hidden.bs.modal', function () {
                XPortal.Store.ForceCloseForm(true);
                if (xdata.State >= 0) {
                    self.FormCloseReload(options, options.button.attr("data-success-url"));
                }
            });
        },
        FormCloseReload: function (settings, directurl) {
            if (settings.action !== "click") return;
            if (XPortal.Store.ForceCloseForm() == false) return;
            if (directurl) window.location.href = directurl;
            else {
                if (settings && settings.notClose) {
                    if (settings.IsCreating) {
                        window.location.href = XPortal.EditForm.ModifyUrlAfterNewRecordSave(window.location.href);
                        return;
                    }
                    window.location.reload(true);
                    return;
                }
                XPortal.EditForm.CloseDetails();
            }
        },
        ShowMailForm: function (options) {
            var deferred = $.Deferred();
            var parameters = {
                options: {
                    showModal: true,
                    IsForm: true,
                    headerText: options.button.attr("data-modaltitle"),
                    confirmationText: options.mailFormText,
                    OnInit: function (elem) {

                        elem.attr('modal-type', 'sendMailModal');
                        if (elem.find(".form-extext-input").length > 0) {
                            let exteditor = $(elem.find(".form-extext-input")[0]);
                            let modelName = XPortal.Store.getModelName($(elem));
                            XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.ADD_MESSAGES, messages: {}, modelName: modelName });
                            XPortal.ExTextEditor.initFor(exteditor, modelName);
                        }
                        var drurl = elem.find(".emailRecipient").attr("data-action");
                        elem.find(".emailRecipient").kendoComboBox({
                            delay: 1500, serverFiltering: true,
                            dataTextField: "title",
                            dataValueField: "email",
                            dataSource: {
                                transport: {
                                    read: function (op) {
                                        var ajaxReq = {
                                            headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() },
                                            method: "POST", dataType: "json", cache: false, contentType: 'application/json',
                                            url: XPortal.Utils.EnsureInProfile(drurl),
                                            data: kendo.stringify(options.recipientOptions),
                                            success: function (xdata) {
                                                op.success(xdata);
                                            },
                                            error: function (jqXHR, textStatus, errorThrown) {
                                                op.error(jqXHR, textStatus, errorThrown);
                                            }
                                        };

                                        $.ajax(ajaxReq);
                                    }
                                }
                            },
                            dataBound: function (e) {
                                if (this.dataSource.view().length > 0) this.select(0);
                            },
                            open: function (e) {
                                XPortal.Utils.identifyKendoPopup(e);
                            },
                            close: function (e) {
                                XPortal.Utils.removeKendoPopupClass(e);
                            }
                        });
                        elem.find(".mailForm").off('submit').on('submit', function (e) {
                            e.preventDefault();
                            var form = elem.find(".mailForm");
                            form.removeData("validator").removeData("unobtrusiveValidation");
                            $.validator.unobtrusive.parse(form);
                            form.data("validator").settings.ignore = ".val-ignore";
                            if (!form.valid()) { return; }
                            XPortal.Loader.show({ 'selector': $('.mailForm') });
                            var rdata = $.extend({}, options.recipientOptions);
                            $.each(elem.find("form").serializeArray(), function () {
                                rdata[this.name] = this.value;
                            });

                            XPortal.Utils.APIPost(form.attr("action"), rdata, { contentType: 'application/json' })
                                .then(function (xdata) {
                                    XPortal.Loader.hide({ 'selector': elem.find(".mailForm") });
                                    deferred.resolve(xdata);
                                })
                                .fail(function (jqXHR) { deferred.fail(jqXHR); });
                        });
                    }
                }
            };

            XPortal.Modal.confirm(parameters);
            XPortal.Main.customThemes();
            return deferred.promise();
        },
        FillHeaders: function (options) {
            var headers = {};
            $.each(options.container.find(".edit-form-head").find("input:hidden"), function (ix, ixel) {
                var xel = $(ixel);
                if (xel.attr("name")) headers[xel.attr("name")] = xel.val();
            });
            return headers;
        },
        NotificationSubscription: function (options) {
            if (!["beforeedit", "click"].includes(options.action)) return;
            options.menuButton = $("#addRemoveNotifications");
            options.command = self.Actions.notificationsubscription;
            if (!options.command) return;
            $(options.command).show();
            if (options.action === "beforeedit") {
                XPortal.Notificator.GetNotificationSubscription(options, function (_element, data) {
                    options.isPresent = data.length > 0;
                    XPortal.Notificator.ToggleSubscriptionAdd(options);
                    XPortal.Loader.hide({ 'selector': options.menuButton });
                });
            }
            if (options.action === "click") {
                XPortal.Notificator.AddRemoveNotificationsSubscription(options);
            }
        },
        Delete: function (options) {
            if (!["beforeedit", "click"].includes(options.action)) return;
            const model = XPortal.Store.GetModelByName(options.modelName).model;
            var ownersOnly = options.button.attr("data-owners-only") === "1";
            if (options.action === "beforeedit") {
                if (model.IsCreating || (ownersOnly && !XPortal.Account.IsSame(model.CreatedBy)))
                    options.button.addClass("inactive");
                return;
            }
            if (options.action === "click") {
                if (!XPortal.Account.Name) {
                    XPortal.Modal.alert({
                        headerText: model.messages.delete.warningtitle,
                        alertText: model.messages.delete.notLoggedIn
                    });
                    return;
                }
                if (ownersOnly) {
                    if (!XPortal.Account.IsSame(model.CreatedBy)) {
                        XPortal.Modal.alert({
                            headerText: model.messages.delete.warningtitle,
                            alertText: model.messages.delete.notCreator
                        });
                        return;
                    }
                }

                let headers = self.FillHeaders(options);
                headers = Object.assign({}, { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() }, headers);
                self.ajaxGetResponse = false;
                $.ajax({
                    type: "post", contentType: 'application/json; charset=utf-8', cache: false,
                    url: XPortal.Utils.EnsureInProfile(options.button.attr("data-deleteRecords")),
                    headers,
                    data: JSON.stringify({
                        NodeId: model.NodeId,
                        EntityAlias: model.Alias,
                        RequestModels: [
                            { EntityAlias: model.Alias, UniqueId: model.UniqueId }]
                    }),
                    success: function (response, status, xhr) {
                        XPortal.Store.ForceCloseForm(true);
                        XPortal.Modal.checkIfModal(response);
                    },
                    error: function (xhr, status, error) {
                        if (console) console.log('DeleteRecords ajax error!');

                    },
                }).done(function () { self.ajaxGetResponse = true; });
            }
        },
        SaveDetail: function (options) {
            
            if (options.action !== "click") return;
            
            var $savingPanel = $('.saving-block');
            var $rightPanel = $('.modal-content.stick-to-the-right');
    
            var loaderSelector = $rightPanel.length ? $savingPanel : null;

            XPortal.Loader.show({'selector': loaderSelector, showOverlay: true, showDelayTime: 0}).show();
            const model = XPortal.Store.GetModelByName(options.modelName).model;
            options.IsCreating = model.IsCreating;
            saveData(options).then(function () {
                XPortal.Loader.hide();
                //TODO - show message about deferred fails?
                const popupObj = $('#gridActionsModalBox');
                const popupOpts = self.InitGenericPopupOptions(popupObj, options.button, '.save-entity-popupcontainer', '.save-entity-container') || {};
                const finalRedirectUrl = options.button.attr("data-finalredirect");

                $("#gridActionsModalBox").on("click", ".close, a.close-modal", function () {
                    XPortal.Modal.hideModal(popupObj, function () { });
                    if (!options.notClose) XPortal.EditForm.CloseDetails();
                    if (finalRedirectUrl && !options.notClose) {
                        XPortal.Store.ForceCloseForm(true);
                        window.location = finalRedirectUrl;
                    }
                });
                if (model.isPopup) return self.popupActionCompleted(options, "SaveDetail", false, finalRedirectUrl);

                if (finalRedirectUrl && !options.notClose && !popupOpts.confirm) {
                    XPortal.Store.ForceCloseForm(true);
                    window.location = finalRedirectUrl;
                }

                if (!finalRedirectUrl && options.IsCreating) {
                    setTimeout(function () {
                        window.location.href = XPortal.EditForm.ModifyUrlAfterNewRecordSave(window.location.href);
                        return;
                    }, popupOpts.confirm == null ? 1 : 2000);
                }
                else if (!finalRedirectUrl && !options.notClose && !popupOpts.confirm) {
                    XPortal.Store.ForceCloseForm(true);
                    XPortal.EditForm.CloseDetails();
                }
            });
        },
        SaveParentDetail(element, iOptions, processError) {
            return new Promise((onOk, onErr) => {
                const el = element ? $(element) : [];
                const form = el.length ? element.closest(XPortal.Main.DetialFormSelector) : [];
                if (!form.length) return onOk();

                const modelName = XPortal.Store.getModelName(form);
                const currentModel = XPortal.Store.GetModelByName(modelName);
                const options = Object.assign({ modelName, container: form, button: null, notClose: true, silentMode: false, doNotDisplayErrors: false, IsCreating: currentModel.model.IsCreating ? true : false }, iOptions);
                XPortal.EditForm.SaveData(modelName, options).then(state => {
                    onOk(state);
                }).fail(function (args) {
                    if (processError) {
                        let xdata = args && args.length > 0 ? args[0] : args || {};
                        var msg = self.Messages.savedetail.captionsavefail;
                        var bodyMessage = self.Messages.savedetail && self.Messages.savedetail.bodysavefail ? self.Messages.savedetail.bodysavefail : "";
                        XPortal.EditForm.ShowErrorMessage(xdata, msg.replace("{detailTitle}", $("h1").length > 0 ? $("h1")[0].innerText : 'entity'), bodyMessage);
                    }
                    return onErr(args);
                });
            });
        },
        SaveDetailPopup: function (settings, isSaved) {
            var model = settings.modelName ? XPortal.Store.GetModelByName(settings.modelName).model : null;
            if (model && model.isPopup) return;
            var popupObj = $('#gridActionsModalBox');
            var popupOpts = self.InitGenericPopupOptions(popupObj, settings.button, '.save-entity-popupcontainer', '.save-entity-container');
            if (!popupOpts) return;
            var curentity = getCurrentEntity(true, settings);
            var activerows = curentity ? [XPortal.Grid.MapEntity(curentity)] : [];
            var successMsg = $(popupOpts.templateContainer.prop("content")).find(".success-msg");
            var errorMsg = $(popupOpts.templateContainer.prop("content")).find(".error-msg");
            if (!successMsg && !errorMsg) return;
            if (activerows.length == 0) return;
            var executeMainLogic = function (isSaved) {
                if (popupOpts.confirm == null) return;
                if (!popupOpts.confirm.options.showModal) return;
                if (isSaved) {
                    errorMsg.addClass("d-none");
                    successMsg.removeClass("d-none");
                    initModalPopup(popupObj, popupOpts);
                    $("#gridActionsModalBox").show();
                    $(".modal-backdrop").show();
                }
                else {
                    errorMsg.removeClass("d-none");
                    successMsg.addClass("d-none");
                }
            };
            executeMainLogic(isSaved);
        },
        GetAutoSaveTimeout: function (settings) {
            var saveCmd = _.find(settings.commands, c => c.action && c.action.toLowerCase() === "savedetail");
            return settings.autoSaverTimeOut = (saveCmd || { autosaveafter: 500 }).autosaveafter;
        },
        ModifyRecord: function (settings) {
            if (settings.action !== "click") return;
            const cmodel = XPortal.Store.GetModelByName(settings.modelName);
            const model = cmodel.model;
            const entityId = model.UniqueId;
            if (!XPortal.Account.Name) {
                XPortal.Modal.alert({
                    headerText: model.messages.modifyentity.warningtitle,
                    alertText: model.messages.modifyentity.notLoggedIn
                });
                return;
            }
            var curentity = getCurrentEntity(true, settings);
            var activerows = curentity ? [XPortal.Grid.MapEntity(curentity)] : [];
            const container = cmodel.model.selector ? $(cmodel.model.selector) : $("[id=detail-" + cmodel.model.NodeId + "]");
            const voptions = { modelName: settings.modelName, container, notClose: true, silentMode: true, doNotDisplayErrors: false, IsCreating: cmodel.model.IsCreating };
            XPortal.EditForm.ValidateAllRelatedModels(container, ".detail-field", voptions, null, cmodel).then(function () {
                XPortal.Store.AppStore.dispatch({ type: "Complex.ModifyRecord.Start", modelName: settings.modelName, button: settings.button });
                self.EnsureAllModelsSaved(() => {
                    ModifySelEntity(activerows, settings.button, container.find(".edit-form"), function (d, popupObj, popupOpts) {
                        if (!d) d = {};
                        if (d.isProcessed) {
                            let action = { type: "Complex.ModifyRecord.Successful", modelName: settings.modelName, options: popupOpts, button: settings.button };
                            XPortal.Store.AppStore.dispatch(action);
                            if (action.options.dontReloadPageInTheEnd) {
                                action = null;
                                console.warn("page reload are blocked by client/redux middleware", action);
                            } else {
                                if (!cmodel.model.isPopup)
                                    setTimeout(function () {
                                        var bc = popupOpts.finalUrl;
                                        XPortal.EditForm.RejectAllChanges();
                                        if (bc) return window.location.href = bc;
                                        else
                                            window.location.reload(true);
                                    }, 300);
                            }
                        }
                        if (!d.isProcessed)
                            XPortal.Store.AppStore.dispatch({ type: "Complex.ModifyRecord.Failed", modelName: settings.modelName, options: popupOpts, button: settings.button });
                        else if (cmodel.model.isPopup)
                            XPortal.Store.AppStore.dispatch({ type: "Complex.ModifyRecord.Successful", modelName: settings.modelName, options: popupOpts, button: settings.button });
                        if (cmodel.model.isPopup) {
                            if (d.isProcessed) self.popupActionCompleted(settings, "ModifyRecord", false, popupOpts.finalUrl);
                        }
                        Reload(null, $(settings.button), popupObj, popupOpts);
                        ReloadAllGrids(null, settings.button, popupObj, popupOpts);
                    }, null, settings.modelName);
                });
            }).catch(function (errors) {
                XPortal.Localization.GetLocalizedStrings("XFModal.Error.Title", "XFModal.Error.Save.Body").then(function (items) {
                    XPortal.EditForm.ShowErrorMessage(errors, items["XFModal.Error.Title"] || "", items["XFModal.Error.Save.Body"] || "");
                });
            });
        },
        ComplexDelete: function (settings) {
            if (settings.action !== "click") return;
            const cmodel = XPortal.Store.GetModelByName(settings.modelName);
            const model = cmodel.model;
            if (!XPortal.Account.Name) {
                XPortal.Modal.alert({
                    headerText: model.messages.complexdelete.warningtitle,
                    alertText: model.messages.complexdelete.notLoggedIn
                });
                return;
            }
            var curentity = getCurrentEntity(true, settings);
            var activerows = curentity ? [XPortal.Grid.MapEntity(curentity)] : [];

            return ComplexDeleteSel(settings.modelName, activerows, settings.button, $(model.selector).find(".edit-form"), function (d, o, s) {
                if (d.isProcessed) {
                    XPortal.EditForm.RejectAllChanges();
                    if (!cmodel.model.isPopup) {
                        var bc = s.finalUrl;
                        if (bc) return window.location.href = bc;
                        window.location.reload(true);
                    }
                }
                if (cmodel.model.isPopup) {
                    if (d.isProcessed) self.popupActionCompleted(settings, "ComplexDelete", false, s.finalUrl);
                }
                Reload(null, $(settings.button), o, s);
            });
        },
        ComplexDeleteItems: function (grid, button, activerows, where) {
            const gridInfo = XPortal.Grid.GetGridInfo(grid);
            var activeDataRow = activerows && activerows.length > 0 ? [gridInfo.kgrid.dataItem(activerows)] : null;
            var rowsToProcessing = where == "row" && activeDataRow ? activeDataRow : getSelectedObjects(grid, false, null);
            if (!rowsToProcessing || rowsToProcessing.length == 0)
                rowsToProcessing = activeDataRow;

            var hdrinfocontainer = grid.closest(".grid-parent");
            var menuButton = hdrinfocontainer.find('.di-content[data-action=' + button.attr("data-action") + ']').first();
            ComplexDeleteSel(gridInfo.modelName, rowsToProcessing, menuButton, hdrinfocontainer, function (d, popupObj, popupOpts) {
                if (d.isProcessed) {
                    var bc = popupOpts.finalUrl;
                    if (bc) {
                        XPortal.EditForm.RejectAllChanges();
                        return window.location.href = bc;
                    };
                }
                Reload(grid, button, popupObj, popupOpts);
                ReloadAllGrids(grid, button, popupObj, popupOpts);
                XPortal.GridActions.UpdateSelectAllCheckbox(grid);
            });
            return true;
        },
        ModifyEntity: function (grid, button, activerows) { // used for complex modify in grid
            var hdrinfocontainer = grid.closest(".grid-parent");
            var gridInfo = XPortal.Grid.GetGridInfo(grid);
            const gridModelIsValid = XPortal.Store.ValidateGridModel(gridInfo.modelName, false, false, true);
            if (!gridModelIsValid) {
                XPortal.Localization.GetLocalizedStrings("XFModal.Error.Title", "XFModal.Error.Save.Body").then(function (items) {
                    XPortal.EditForm.ShowErrorMessage({ validationErrors: [`<p>${XPortal.Grid.GetGridValidationError(XPortal.Store.GetModelByName(gridInfo.modelName), false)}</p>`] }, items["XFModal.Error.Title"] || "", items["XFModal.Error.Save.Body"] || "");
                });
                return;
            }
            self.EnsureAllModelsSaved(() => {
                ModifySelEntity(getSelectedObjects(grid, true, activerows), button, hdrinfocontainer, function (d, popupObj, popupOpts) {
                    if (d.isProcessed) {
                        XPortal.Store.AppStore.dispatch({ type: "Complex.ModifyRecord.Successful", modelName: gridInfo.modelName, options: popupOpts, button });
                        var bc = popupOpts.finalUrl;
                        if (bc) {
                            XPortal.EditForm.RejectAllChanges();
                            return window.location.href = bc;
                        };
                    } else
                        XPortal.Store.AppStore.dispatch({ type: "Complex.ModifyRecord.Failed", modelName: gridInfo.modelName, options: popupOpts, button });
                    Reload(grid, button, popupObj, popupOpts);
                    ReloadAllGrids(grid, button, popupObj, popupOpts);
                }, null, gridInfo.modelName);
            });
            return true;
        },
        Custom: function (options) {
            if (options.action !== "click") return;
            const $btn = $(options.button);
            const cmodel = (XPortal.Store.GetModelByName(options.modelName) || {}).model;
            const curentity = cmodel ? getCurrentEntity(true, options) : null;
            const selrows = curentity ? [XPortal.Grid.MapEntity(curentity)] : [];

            const pinfo = XPortal.Template.GetObjPropValueByName(cmodel, "parentInfo");
            XPortal.GridActions.ShowPage({
                action: function () {
                    const opts = JSON.parse($btn.attr("data-href"));
                    XPortal.Loader.show({ 'selector': null, showOverlay: true, autoHideTime: 3000, showDelayTime: 1 });
                    XPortal.Store.WaitForAllModelsSaveDone().finally(() => {
                        XPortal.Loader.hide({ 'selector': null, showOverlay: true });
                    }).then(() => {
                        const popupContainer = cmodel ? $(cmodel.selector).closest('#extended-popup-box') : [];
                        if (popupContainer.length)
                            XPortal.EditForm.CleanUpPopupPageModels({ currentTarget: popupContainer }, {});
                        return XPortal.EditForm.LinkAction(opts, curentity, { modelName: options.modelName, nodeId: cmodel.NodeId, button: $btn, selrows, where: null, pinfo });
                    }).catch(() => { });
                }
            });
        },
        EnsureAllModelsSaved: function (onSaved) {
            XPortal.Loader.show({ 'selector': null, showOverlay: true });
            XPortal.Store.WaitForAllModelsSaveDone().finally(() => {
                XPortal.Loader.hide({ 'selector': null, showOverlay: true });
            }).then(onSaved).catch(() => {
                XPortal.Localization.GetLocalizedStrings("XFModal.Error.Title", "XFGrid.Command.ModifyRecordError").then(function (items) {
                    XPortal.EditForm.ShowErrorMessage([], items["XFModal.Error.Title"] || "", items["XFGrid.Command.ModifyRecordError"] || "");
                });
            });
        },
        InitGenericPopupOptions: function (popupObj, button, containerSel, settgsContainerSel) {
            popupObj.off("click").off("focusout").off("keyup").off("keypress");
            if (!button || !button.length) return;
            var mtcontainer = button.closest('.dropdown-item').find(containerSel);
            var popupOptsContainer = $(mtcontainer.prop('content')).find(settgsContainerSel);
            let settingsAttr = popupOptsContainer.attr("data-settings");
            if (settingsAttr == null || !settingsAttr.length) return;
            var popupOpts = JSON.parse(settingsAttr);
            popupOpts.SubmitUrl = popupOptsContainer.attr("data-src");
            popupOpts.showStep = function (stepSelector, evnName, ipopupObj) {
                ipopupObj = ipopupObj ? ipopupObj : popupObj;
                ipopupObj.find(".wsection").addClass("d-none");
                ipopupObj.find(".modal-body-footer a").hide();
                ipopupObj.find(stepSelector).removeClass("d-none");
                if (evnName) ipopupObj.trigger(evnName);
                initKendoStepper(ipopupObj, popupOpts, evnName);
            };
            popupOpts.templateContainer = mtcontainer;
            return popupOpts;
        },
        TransformPopupTemplate: transformToOTemplate,
        popupActionCompleted: function (options, actionName, closeModal, redirectToUrl) {
            const $modalDialog = options.button && options.button.length ? options.button.closest(".modal-dialog") : options.container.closest(".modal-dialog");
            const evobj = { actionName, modelName: options.modelName, closeModal, redirectToUrl };
            if (!options.notClose) $modalDialog.trigger("action-completed", evobj);
            else if (options.silentMode) {
                $modalDialog.trigger("refresh-org-grid", evobj);
            }
        }
    };
    function ensureDefaultActions(settings, container) {
        const nodeid = settings.id = container ? $(container).attr("data-nid") : "";
        settings.commands = settings.commands || {};
        settings.messages = settings.messages || {};
        if (settings.id) self.NodeActions[nodeid] = settings;
        self.autoSaverTimeOut = self.GetAutoSaveTimeout(settings);
        self.Actions = settings.commands;
        self.Messages = settings.messages;
        return settings;
    }
    function initNotifications(settings) {
        let $menuItem = $("#addRemoveNotifications");
        if (!$menuItem) return;
        let container = settings.container || $(XPortal.Main.DetialFormSelector);
        var saveCmd = _.find(settings.commands, c => c.action.toLowerCase() === "notificationsubscription");
        if (saveCmd) {
            $menuItem.on("click", function (e) {
                e.preventDefault();
                var $button = container.find(".detail-toolbar").first().find("[data-action=" + saveCmd.action + "]:visible").first();
                self.Exec(self.Actions.notificationsubscription.action, { container: container, button: $button, action: "click" }, settings);
            });
            $menuItem.parent().show();
        } else
            $menuItem.parent().hide();
    }
    function saveData(options) {
        return XPortal.EditForm.SaveData(options.modelName, options)
            .fail(function (args) {
                XPortal.Loader.hide();
                const xdata = args && args.length > 0 ? args[0] : args || {};
                if (!xdata.hasOwnProperty("validationErrors"))
                    xdata.validationErrors = XPortal.EditForm.GetErrorMessages([xdata]);
                XPortal.Localization.GetLocalizedStrings("XFModal.Error.Title", "XFModal.Error.Save.Body").then(function (items) {
                    XPortal.EditForm.ShowErrorMessage(xdata, items["XFModal.Error.Title"].replace("{detailTitle}", $("h1").length > 0 ? $("h1")[0].innerText : 'entity'), items["XFModal.Error.Save.Body"]);
                });
            });
    }
    function CloseModal(data) {
        if (data !== null) {
            var form = data.closest('form');
            if (form) form.off();
        }
    };
    function getCurrentEntity(createDefault, settings) {
        const cmodel = XPortal.Store.GetModelByName(settings.modelName);
        let curentity = cmodel.entity;
        if (!curentity) {
            if (!createDefault) return curentity;
            curentity = { uniqueId: cmodel.model.UniqueId, Fields: [] };
            curentity.Fields = XPortal.EditForm.ProcessDetailFields($(cmodel.model.selector)) || [];
            curentity.Fields.push({ field: "uniqueId", data: cmodel.model });
            curentity.Fields = [...new Map(curentity.Fields.map(x => [x['field'], x])).values()];
        }
        if (curentity)
            curentity.Fields.forEach(function (f) {
                var fname = XPortal.Template.GetObjPropName(f, "Name");
                var fdata = XPortal.Template.GetObjPropName(f, "StringValue");
                if (!f[fname]) f[fname] = f[XPortal.Template.GetObjPropName(f, "field")];
                if (!f[fdata]) f[fdata] = f[XPortal.Template.GetObjPropName(f, "data")];
            });
        return curentity;
    };
    function getSelectedObjects(grid, setCheck, rowstoprocess) {
        var gridInfo = XPortal.Grid.GetGridInfo(grid);
        var selectedrows = rowstoprocess ? rowstoprocess : XPortal.GridActions.GetActiveRows(gridInfo, setCheck);
        var objects = [], ids = [];
        _.each(selectedrows, function (row) {
            var o = gridInfo.kgrid.dataItem(row);
            if (o == undefined) return objects;
            var id = o.UniqueId === null ? o.uniqueid : o.UniqueId;
            if (!ids.includes(id)) {
                ids.push(id);
                objects.push(o);
            }
        });
        return objects;
    };
    function renderFinalConfirmation(popupObj, popupOpts, activerows, data) {
        var mStatuses = [];
        var isProcessed = true;
        for (var sii in data.Statuses) {
            var si = data.Statuses[sii];
            mStatuses.push(si);
            isProcessed = isProcessed && si.IsProcessed && si.IsValid;
            var aorow = activerows.find(function (axi) { return axi.uniqueid == sii || axi.UniqueId == sii; });
            si.orderTitle = XPortal.Template.ReplaceFormatString(popupOpts.messages.selorderFormat, null, aorow, {}) || "";
        }
        data.Statuses = mStatuses;
        data.isProcessed = isProcessed;
        var rhtml = kendo.template(popupObj.find(".wsection .processed-status-template").html())(data);
        popupObj.find(".processed-status-step2").html(rhtml);
        popupObj.attr('modal-type', 'xl-width');
        ReinitShowMore(popupObj, popupOpts);
        return data;
    };
    function initModalPopup(popupObj, popupOpts, onbeforeRender, onAfterRender, onClose, disableCloseOnOverlayClick, onDismissing) {
        var copyId = $(popupObj).attr("id") + "_ihtml";
        if ($("#" + copyId).length == 0) {
            $("<div class='d-none invisible'/>")
                .attr("id", copyId)
                .html($(popupObj).html())
                .appendTo($(popupObj).parent());
        } else
            $(popupObj).empty().html("").html($("#" + copyId).html());

        XPortal.Modal.prepareModalFromTemplate(popupOpts.templateContainer, !!disableCloseOnOverlayClick, onClose || null, popupObj, {
            beforeRender: function (el, stgs) {
                var bcontent = el.find('.modal-body').find(".modal-body-footer");
                var cntr = el.find(".modal-content");

                bcontent.detach();
                el.find('.modal-footer').html('');
                bcontent.appendTo(el.find('.modal-footer'));
                if (popupOpts.width) {                    
                    cntr.attr("class", "modal-content");
                    cntr.addClass(popupOpts.width).addClass("custom-popup-width");
                }
                (popupOpts.cssStyle || []).forEach(x => {
                    cntr.addClass(x);
                });
                if (onbeforeRender) onbeforeRender();
            },
            afterRender: function () { if (onAfterRender) onAfterRender(); },
            onDismissing: onDismissing || popupObj.onDismissing
        });
        return $(popupObj);
    };
    self.initModalPopup = initModalPopup;
    function transformToOTemplate(activerows, popupOpts, rowslength) {
        var templateText = activerows.length > 1 ? popupOpts.messages.confirmationBody : popupOpts.messages.confirmationBodySinlge || popupOpts.messages.confirmationBody;
        var combinedInfo = "<div class='sel-records-list'><ul>";
        if ((popupOpts.messages.selorderFormat || "").length > 0)
            activerows.forEach(function (v, vi) {
                var ri = XPortal.Template.ReplaceFormatString(popupOpts.messages.selorderFormat, null, v, {});
                if (ri && ri.length)
                    combinedInfo = combinedInfo + "<li>" + ri + "</li>";
            });
        combinedInfo = combinedInfo + "</ul></div>";
        rowslength = rowslength ? rowslength : activerows.length;
        return XPortal.Template.ReplaceFormatString(templateText, null, { length: rowslength, count: rowslength, list: combinedInfo }, {});
    };
    function initKendoStepper(popupObj, setts, stepName) {
        var xselector = popupObj.find(".xwstepper");
        try {
            XPortal.Grid.ResizeGrid(getSourceGrid(popupObj, setts));
        }
        catch (e) { }
        if (!popupObj.stepper || !popupObj.stepper.disabled) {
            popupObj.stepper = popupObj.stepper || {};
            if ($(xselector).kendoStepper)
                popupObj.stepper.control = $(xselector).kendoStepper({
                    steps: [{
                        label: "Initial step",
                        selected: true,
                    }, {
                        label: "Second step",
                        successIcon: "plus"
                    }, {
                        label: "Third step",
                        selected: true
                    }]
                });
        }
    };
    function Reload(grid, commandElement, pobj, pobjSettings) {
        if (grid) {
            grid.data("kendoGrid").dataSource.read();
            grid.data("kendoGrid").refresh();
        }
        ReinitShowMore(pobj, pobjSettings);
    };
    function ReloadAllGrids(xitemToSkip, button, popupObj, popupOpts) {
        var itemToSkip = !xitemToSkip ? false : xitemToSkip.length ? xitemToSkip[0] : xitemToSkip;
        $(".detailblock-viewcontainer").each(function () {
            $(this).removeAttr("data-pid");//to reload detail page
        });
        for (var mkey in XPortal.Store.GetState().pageModels) {
            if (mkey.substr(0, 3).toLowerCase() == "gm.") {
                var xmodel = XPortal.Store.GetState().pageModels[mkey];
                var gridItems = $('.grid-parent .entity-grid').filter(function (ix, x) {
                    return $(x).attr("data-id") == xmodel.model.NodeId;
                });
                if (gridItems.length > 0) {
                    gridItems.each(function () {
                        if (itemToSkip != this) {
                            var this$ = $(this);
                            this$.data("kendoGrid").dataSource.read();
                            this$.data("kendoGrid").refresh();
                            setTimeout(function () { this$.trigger("grid.onsearch"); }, 500);
                        }
                    });
                }
            }
        };
        ReinitShowMore(popupObj, popupOpts);
    };
    function ReinitShowMore(pobj, pobjSettings) {
        if (!pobj) return;

        pobj.find(".d-show-hide-more").off("click");
        pobj.find(".d-show-hide-more").on("click", function () {
            var el = $(this);
            el.closest(".row").find(".d-more").toggleClass("d-none");
            el.find(".fa").toggleClass("fa-caret-right").toggleClass("fa-caret-up");
        });
    };
    function ModifySelEntity(activerows, button, hdrinfocontainer, iondone, onsave, modelName) {
        var popupObj = $('#gridActionsModalBox');
        var popupOpts = self.InitGenericPopupOptions(popupObj, button, '.modify-entity-popupcontainer', '.modify-entity-container');
        var idata = null;
        if (activerows.length === 0)
            return XPortal.Modal.alert({
                headerText: popupOpts.error.headerText,
                alertText: XPortal.GridActions.GetWarningMsg(button.closest(".toolbar"))
            });

        var executeMainLogicAndSaveIfNeeded = function (skipValidationConfirmed) {
            if (!$(button).attr("data-save-before-action") || !onsave) executeMainLogic(skipValidationConfirmed);
            if (onsave) onsave().then(function () { executeMainLogic(skipValidationConfirmed); }, () => { });
        };
        var executeMainLogic = function (skipValidationConfirmed) {
            initModalPopup(popupObj, popupOpts, null, null, function (e) {
                iondone(idata, popupObj, popupOpts);
            });
            popupOpts.showStep(".wsection.modify-step-intro");
            XPortal.Loader.show({ selector: popupObj });

            var result = new $.Deferred();
            var url = popupObj.find(".modify-processing").attr("data-src");
            var data = { key: popupOpts.key, nodeid: popupOpts.nodeId, EntityIds: activerows.map((x) => x[XPortal.Template.GetObjPropName(x, "uniqueId")]), skipValidationConfirmed: skipValidationConfirmed, ParentInfo: XPortal.Grid.GetModelParentInfo(modelName) };
            var ajaxReq = {
                method: "POST", dataType: "json", cache: false, contentType: 'application/json', url: XPortal.Utils.EnsureInProfile(url), data: kendo.stringify({ model: data }),
                headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken(hdrinfocontainer.length ? hdrinfocontainer : $("body")) },
                success: function (xdata) { result.resolve(xdata); },
                error: function (jqXHR, textStatus, errorThrown) { result.resolve(); }
            };
            popupObj.find(".modify-processing").find("input").map(function (ix, x) { ajaxReq.headers[$(x).attr("name")] = $(x).val(); });
            $.ajax(ajaxReq);
            result.then(function (data) {
                XPortal.Loader.hide({ selector: popupObj });
                if (!data) return popupOpts.showStep(".wsection.error");

                popupOpts.showStep(".wsection.modify-step-confirm");
                idata = renderFinalConfirmation(popupObj, popupOpts, activerows, data);
                if (!idata.isProcessed) {
                    popupOpts.showStep(".wsection.modify-step-confirm", "awpobj.result");
                    popupObj.find(".modal-body-footer a").show();
                    if (idata.CouldBeSkipped) {
                        popupObj.find(".modal-body-footer .validationskipped-btn").removeClass("d-none");
                        popupObj.find(".modal-body-footer .validationskipped-btn").show();
                    } else {
                        popupObj.find(".modal-body-footer .validationskipped-btn").addClass("d-none");
                        popupObj.find(".modal-body-footer .validationskipped-btn").hide();
                    }
                }
                else {
                    popupObj.find(".modal-body-footer .validationskipped-btn").addClass("d-none");
                    popupObj.find(".modal-body-footer .validationskipped-btn").hide();
                }
                if (popupOpts.showConfirmation || !idata.isProcessed)
                    popupObj.find(".modal-body-footer a.close-modal").show();
                else
                    popupObj.find(".modal-body-footer a.close-modal").trigger("click");
            });
            return result;
        };
        if (popupOpts.confirm) {
            popupOpts.confirm.options.confirmationText = transformToOTemplate(activerows, popupOpts);
            XPortal.Modal.confirm(popupOpts.confirm, function (r) {
                if (r.result == 'yes') executeMainLogicAndSaveIfNeeded(false);
                else if (r.result == 'no') XPortal.Store.AppStore.dispatch({ type: "Complex.ModifyRecord.Canceled", modelName, options: popupOpts, button });
            });
        } else
            executeMainLogicAndSaveIfNeeded(false);
        popupObj.on("click", "button", function (e) {
            var el = $(this);
            if (el.hasClass("validationskipped-btn")) {
                executeMainLogicAndSaveIfNeeded(true);
            }
        });
    };
    function ComplexDeleteSel(modelName, activerows, button, hdrinfocontainer, ondone) {
        var popupObj = $('#gridActionsModalBox');
        var popupOpts = self.InitGenericPopupOptions(popupObj, button, '.complex-delete-popupcontainer', '.complex-delete-container');
        var idata = null;

        if (!activerows || activerows.length === 0)
            return XPortal.Modal.alert({
                headerText: popupOpts.error.headerText,
                alertText: XPortal.GridActions.GetWarningMsg(button.closest(".toolbar")) || XPortal.GridActions.GetWarningMsg(button) || "There are no records selected. Select at least one record and try again."
            });
        ondone = ondone || function () { };
        var rowsToDelete = [];
        var ownerOnly = button.attr("data-owners-only") === "1";
        _.each(activerows, function (x) {
            rowsToDelete.push(x);
        });

        var executeMainLogic = function () {
            if (activerows.length == 1 && activerows[0].IsCreating) {
                return ondone({ isProcessed: true }, popupObj, popupOpts);
            }
            $('#gridActionsModalBox').off("click");
            initModalPopup(popupObj, popupOpts, false, false, function (e) {
                ondone(idata, popupObj, popupOpts);
            });
            popupObj = $('#gridActionsModalBox');
            popupOpts.showStep(".wsection.delete-step-intro");
            XPortal.Loader.show({ selector: popupObj });

            var result = new $.Deferred();
            var url = popupObj.find(".delete-processing").attr("data-src");
            var data = { key: popupOpts.key, nodeid: popupOpts.nodeId, EntityIds: rowsToDelete.map((x) => x[XPortal.Template.GetObjPropName(x, "uniqueId")]), ParentInfo: XPortal.Grid.GetModelParentInfo(modelName) };
            var ajaxReq = {
                method: "POST", dataType: "json", cache: false, contentType: 'application/json', url: XPortal.Utils.EnsureInProfile(url), data: kendo.stringify({ model: data }),
                headers: { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken(hdrinfocontainer) },
                success: function (xdata) { result.resolve(xdata); },
                error: function (jqXHR, textStatus, errorThrown) { result.resolve(); }
            };
            popupObj.find(".delete-processing").find("input").map(function (ix, x) { ajaxReq.headers[$(x).attr("name")] = $(x).val(); });
            $.ajax(ajaxReq);
            result.done(function (data) {
                XPortal.Loader.hide({ selector: popupObj });
                if (!data) return popupOpts.showStep(".wsection.error");
                idata = renderFinalConfirmation(popupObj, popupOpts, activerows, data);
                popupOpts.showStep(".wsection.delete-step-confirm");
                popupObj.find(".modal-body-footer a").show();
            });
            return result;
        };
        if (popupOpts.confirm) {
            popupOpts.confirm.options.confirmationText = transformToOTemplate(rowsToDelete, popupOpts);
            XPortal.Modal.confirm(popupOpts.confirm, function (r) { if (r.result != 'yes') return; executeMainLogic(); });
        } else executeMainLogic();
        return true;
    };

    function smoothChangeView() {
        const scrollHeight = document.documentElement.scrollHeight;
        const clientHeight = document.documentElement.clientHeight;
        const hasScrollbar = scrollHeight > clientHeight + 1;
                
        $('html').toggleClass("prevent-shift", hasScrollbar);
    };

    function cleanHtmlEditorForViewMode(containerSelector) {
      $(containerSelector)
        .find(".kendoo-html-editor iframe")
        .each(function () {
          const ifr = this;
          const applyInternalStyles = () => {
            try {
                const innerDoc = ifr.contentDocument || ifr.contentWindow.document;
                if (!innerDoc || !innerDoc.body) return;

                const textContent = innerDoc.body.textContent || innerDoc.body.innerText || "";
                const cleanText = textContent.replace(/[\s\u00a0]/g, "");
                if (cleanText.length === 0) {
                    $(ifr).closest(".kendoo-html-editor").addClass("is-empty");
                }

                innerDoc.body.style.cssText = `
                padding: 0 !important;
                height: auto !important;
                min-height: 0 !important; `;

                // In view mode the editor is sized by its content - that is its
                // natural height here (no toolbar, no frame, just the text).
                const toContentHeight = function () {
                    $(ifr).closest(".k-editable-area").css("height", "auto");
                    $(ifr).closest(".k-editor").css("height", "auto");
                    const newHeight = innerDoc.body.scrollHeight;
                    ifr.style.height = (newHeight > 0 ? newHeight : 20) + "px";
                };
                toContentHeight();

                // ...and, starting from that height, it still has to take the
                // height left over by the section, just like the editable one (#13186).
                if (XPortal.ExTextEditor)
                    XPortal.ExTextEditor.fitToSection($(ifr).closest(".kendoo-html-editor"), toContentHeight);
                } catch (e) {
            }
          };

          if (ifr.contentDocument && ifr.contentDocument.readyState === "complete") {
            applyInternalStyles();
          } else {
            ifr.onload = applyInternalStyles;
          }
        });
    }

    return self;
}());